export const TYPE = Object.freeze({
    SUCCESS: 'success',
    INFO:    'info',
    WARNING: 'warning',
    ERROR:   'error',
});
